<template>
  <div class="search-form-section">
    <div class="search-form-section__filters">
      <price-form-parts
        v-if="type !== 'test'"
        :valueMin="searchValue.price_from"
        :valueMax="searchValue.price_to"
        @inputMin="changePriceMin"
        @inputMax="changePriceMax"
      />

      <select-form-parts
        inputName="search_displacement"
        label="排気量"
        :value="searchValue.displacement"
        :options="DISPLACEMENT"
        @changeInput="changeDisplacement"
      />

      <select-form-parts
        v-if="type === 'used'"
        inputName="search_mileage"
        label="走行距離"
        :value="searchValue.mileage"
        :options="MILEAGE"
        @changeInput="changeMileage"
      />

      <select-shop-parts
        blankOption="店舗名またはご希望のエリアを選択してください"
        inputName="search_shop"
        label="店舗名"
        :value="String(searchValue.dealer)"
        :options="DEALER.area"
        @changeInput="changeShop"
      />
    </div>

    <checkbox-form-parts
      v-if="searchValue.displacement"
      class="model-list"
      style="margin-bottom: 0;"
      inputName="model_name"
      label="車種名"
      :checkboxValues="bikeList"
      :selectedBikes="selectedBikes"
      @update:checkboxValues="updateBikeCheck"
    />
  </div>
</template>

<script>
import {defineComponent, computed} from 'vue'
import {Util} from '../../master.js'
import SelectFormParts from './parts/SelectFormParts.vue'
import SelectShopParts from './parts/SelectShopParts.vue'
import TextFormParts from './parts/TextFormParts.vue'
import PriceFormParts from './parts/PriceFormParts.vue'
import CheckboxFormParts from './parts/CheckboxFormParts.vue'

export default defineComponent({
  name: 'SearchFormSection',
  components: {
    SelectShopParts,
    SelectFormParts,
    TextFormParts,
    PriceFormParts,
    CheckboxFormParts,
  },
  props: {
    search: {
      type: Object,
      required: true,
    },
    bikeList: {
      type: Array,
      required: true,
      default: () => [],
    },
    selectedBikes: {
      type: Array,
      required: true,
      default: () => [],
    },
    type: {
      type: String,
      default: 'new',
    }
  },
  setup(props, context) {
    const {MILEAGE, DEALER} = Util
    const DISPLACEMENT = props.type === 'unused' ? Util.DISPLACEMENT_UNUSED : Util.DISPLACEMENT
    const searchValue = computed(() => props.search)

    const changeDisplacement = (val) => {
      context.emit('changeDisplacement', val)
    }

    const changeMileage = (val) => {
      context.emit('changeMileage', val)
    }

    const changeShop = (val) => {
      context.emit('changeShop', val)
    }

    const changePriceMin = (val) => {
      context.emit('changePriceMin', val)
    }

    const changePriceMax = (val) => {
      context.emit('changePriceMax', val)
    }

    const updateBikeCheck = (val) => {
      context.emit('updateBikeCheck', val)
    }

    return {
      searchValue,
      DISPLACEMENT,
      MILEAGE,
      DEALER,
      changeDisplacement,
      changeMileage,
      changeShop,
      changePriceMin,
      changePriceMax,
      updateBikeCheck,
    }
  },
})
</script>
